import React, { useEffect, useMemo, useState } from "react";
import styles from "./ModalRoleAssign.module.scss";

import { Avatar, Col, Modal, Row, Spin, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { LoadingOutlined } from "@ant-design/icons";
import useFetch, { CachePolicies } from "use-http";

import searchIcon from "src/assets/png/searchIcon.png";
import selectedItemShare from "src/assets/png/selectedItemShare.png";
import ButtonCenterClose from "src/components/shared/button/CloseButton/ButtonCenterClose";
import CenterButton from "src/components/shared/button/CenterButton";
import { promoteRole } from "./Member";
import { getUserData } from "src/service/auth.service";
import { useAppSelector } from "src/hooks";
import { profile } from "src/features/profile/profileSlice";
// import { T } from "antd/lib/upload/utils";

const ModalRoleAssign = (props: any) => {
  const { member, onPromoted, context, visible } = props;
  const { t } = useTranslation();
  const myProfile = useAppSelector(profile);
  // const chatCtx: any = useContext(ChatContext);
  // const appCtx: any = useContext(AppContext);
  const [selectedUsers, setSelectedUsers]: any = useState([]);
  const [selectedNums, setSelectedNums] = useState(0);
  const [search, setSearch] = useState("");
  const [searchedMember, setSearchedMember] = useState([]);
  const [timer, setTimer]: any = useState();

  const promote = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v2/groups",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const memberFilter: any = useMemo(() => {
    const _memberFilter: any = member ? [...member] : [];

    if (context?.promoteMember === promoteRole.removeFromGroup) {
      return _memberFilter?.filter((member: any) => {
        if (!member?.user) return
        return member?.userID !== getUserData().id
        // && member.memberRole !== "owner"
      });
    } else if (context?.promoteMember === promoteRole.removeMember ||
      context?.promoteMember === promoteRole.admin) {
      return _memberFilter?.filter((member: any) => {
        if (!member?.user) return
        return (
          member?.userID !== myProfile.id &&
          member.memberRole === "member"
        );
      });
    } else if (context?.promoteMember === promoteRole.owner) {
      return _memberFilter?.filter((member: any) => {
        if (!member?.user) return
        return (
          member?.userID !== myProfile.id &&
          member.memberRole !== "owner"
        );
      });
    } else if (context?.promoteMember === promoteRole.removeOwner) {
      return _memberFilter?.filter((member: any) => {
        if (!member?.user) return
        return (
          member?.userID !== myProfile.id &&
          member.memberRole === "owner"
        );
      });
    } else {
      return _memberFilter?.filter((member: any) => {
        if (!member?.user) return
        return (
          member?.userID !== myProfile.id &&
          member.memberRole === "admin"
        );
      });
    }
  }, [context.promoteMember]);

  const headerText: string = useMemo(() => {
    if (context?.promoteMember === promoteRole.removeFromGroup) {
      return t(`Remove user`);
    } else if (context?.promoteMember === promoteRole.removeOwner) {
      return t(`Remove owner`);
    } else if (context?.promoteMember === promoteRole.removeMember) {
      return t(`Remove member`);
    } else if (context?.promoteMember !== promoteRole.removeAdmin) {
      return t(`Promote ${context.promoteMember}`);
    } else {
      return t(`Remove admin`);
    }
  }, [context.promoteMember]);

  const handleClosePopup = () => {
    setSelectedNums(0);
    setSelectedUsers([]);
    context.setPromoteMember(null);
    context.setSelectedUserId([]);
  };

  useEffect(() => {
    if (!props.defaultMembers || props.defaultMembers.length === 0) return;
    setSelectedUsers(props.defaultMembers);
    setSelectedNums(props.defaultMembers.length);
  }, [props.defaultMembers])

  const handleSearch = (event: any) => {
    const value = event.target.value;
    setSearch(value);
    clearTimeout(timer!);
    setTimer(
      //@ts-ignore
      setTimeout(() => {
        const findMember = memberFilter.filter((member: any) => {
          return member?.user?.firstname?.match(`^${value}`, "i");
        });

        setSearchedMember(findMember);
      }, 500)
    );
  };

  const handleSelect = (id: string) => {
    var check = false;
    let arr: any = selectedUsers;

    if (context?.promoteMember !== promoteRole.owner) {
      for (let i = 0; i < arr.length; i++) {
        if (id === arr[i]) {
          arr.splice(i, 1);
          check = true;
          break
        }
      }
      if (!check) {
        arr.push(id)
      }
      setSelectedNums(arr.length);
      setSelectedUsers(arr);
    } else {
      arr = [];
      arr.push(id)
      if(arr[0] === selectedUsers[0]){
        arr = [];
      }
      setSelectedNums(arr.length);
      setSelectedUsers(arr);
    }
    // console.log("arr :: >", arr);
    // console.log("selectedUsers", selectedUsers);
    // console.log("Check...", check);
  };

  const handleAssignRole = async () => {
    let actionUrl: string;
    if (context?.promoteMember === promoteRole.removeFromGroup ||
      context?.promoteMember === promoteRole.removeMember) {
      //to remove user from group
      actionUrl = `/owner-remove-users`;
    } else if (context?.promoteMember === promoteRole.removeOwner) {
      //to remove Owner
      actionUrl = `/removes-owner`;
    } else if (context?.promoteMember !== promoteRole.removeAdmin) {
      //to promote Admin or Owner
      actionUrl = `/promotes-${context.promoteMember}`;
    } else {
      //to remove Admin
      actionUrl = `/removes-admin`;
    }

    try {
      let payload: any = {
        groupID: member[0]?.groupID,
        userID: selectedUsers,
      };
      console.log("payload", payload);

      if (context?.promoteMember === promoteRole.removeFromGroup) {
        payload.removeByID = getUserData().id;
      }
      await promote.post(actionUrl, payload);
      await onPromoted(member[0]?.groupID);
      setSelectedNums(0);
      setSelectedUsers([]);
      context.setPromoteMember(null);
    } catch (error) {
      console.error(error);
    }
  };

  const checkCommunity = () => {
    if (
      window.location.href.indexOf("/group-community") !== -1 &&
      !props?.community
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    console.log("selecteUsers", selectedUsers);

  }, [selectedUsers])

  return (
    <Modal
      centered
      open={visible}
      className={styles.modalOveride}
      onCancel={handleClosePopup}
    >
      <div style={{ position: "absolute", top: 19, right: 19 }}>
        <ButtonCenterClose onClick={handleClosePopup} />
      </div>

      <div className={styles.popupContainer}>
        <div className={styles.popupTitle} style={{ paddingBottom: 20 }}>
          {headerText}
        </div>

        <div className={styles.searchContainer} style={{ marginBottom: 20 }}>
          <div
            className={styles.searchIcon}
            style={{ backgroundImage: `url(${searchIcon})` }}
          />
          <input
            type="text"
            className={styles.searchInput}
            placeholder={t("Search")}
            value={search}
            onChange={handleSearch}
          />
        </div>

        <div className={styles.selectedHeader}>
          {t("Selected Friend")} ({selectedNums})
        </div>
        <Row style={{ height: "50vh", overflow: "auto" }} gutter={[16, 16]}>
          {search === ""
            ? memberFilter?.map((item: any, idx: number) => {
              const name = `${item?.user?.firstname} ${item?.user?.lastname ? item?.user?.lastname : ""
                }`;
              return (
                <Col span={6}>
                  <FriendForSelect
                    key={idx}
                    name={name}
                    profileImage={item?.user?.imageProfileURL}
                    userid={item?.userID}
                    selected={selectedUsers?.includes(item?.userID)}
                    onSelect={() => {
                      handleSelect(item?.userID);
                    }}
                  />
                </Col>

              );
            })
            : searchedMember.map((item: any, idx: number) => {
              const name = `${item?.user?.firstname} ${item?.user?.lastname ? item?.user?.lastname : ""
                }`;
              return (
                <Col span={6}>
                  <FriendForSelect
                    key={idx}
                    name={name}
                    profileImage={item?.user?.imageProfileURL}
                    userid={item?.userID}
                    selected={selectedUsers?.includes(item?.userID)}
                    onSelect={() => {
                      handleSelect(item?.userID);
                    }}
                  />
                </Col>
              );
            })}
        </Row>
        {/* <div className={styles.friendListContainer}>*/}
        {/*  {search === ""*/}
        {/*    ? memberFilter?.map((item: any, idx: number) => {*/}
        {/*        const name = `${item?.user?.firstname} ${*/}
        {/*          item?.user?.lastname ? item?.user?.lastname : ""*/}
        {/*        }`;*/}
        {/*        return (*/}
        {/*          <FriendForSelect*/}
        {/*            key={idx}*/}
        {/*            name={name}*/}
        {/*            profileImage={item?.user?.imageProfileURL}*/}
        {/*            userid={item?.userID}*/}
        {/*            selected={selectedUsers?.includes(item?.userID)}*/}
        {/*            onSelect={() => {*/}
        {/*              handleSelect(item?.userID);*/}
        {/*            }}*/}
        {/*          />*/}
        {/*        );*/}
        {/*      })*/}
        {/*    : searchedMember.map((item: any, idx: number) => {*/}
        {/*        const name = `${item?.user?.firstname} ${*/}
        {/*          item?.user?.lastname ? item?.user?.lastname : ""*/}
        {/*        }`;*/}
        {/*        return (*/}
        {/*          <FriendForSelect*/}
        {/*            key={idx}*/}
        {/*            name={name}*/}
        {/*            profileImage={item?.user?.imageProfileURL}*/}
        {/*            selected={selectedUsers?.includes(item?.userID)}*/}
        {/*            onSelect={() => {*/}
        {/*              handleSelect(item?.userID);*/}
        {/*            }}*/}
        {/*          />*/}
        {/*        );*/}
        {/*      })}*/}
        {/*</div> */}

        <div style={{ marginTop: 42 }}></div>
        {promote.loading || selectedNums === 0 ? (
          <CenterButton ghost disabled>
            {context?.promoteMember !== promoteRole.removeAdmin &&
              context?.promoteMember !== promoteRole.removeMember &&
              context?.promoteMember !== promoteRole.removeOwner &&
              context?.promoteMember !== promoteRole.removeFromGroup
              ? t("Add")
              : t("Remove")}
          </CenterButton>
        ) : (
          <CenterButton onClick={handleAssignRole}>
            {!promote.loading ? (
              context?.promoteMember !== promoteRole.removeAdmin &&
                context?.promoteMember !== promoteRole.removeMember &&
                context?.promoteMember !== promoteRole.removeOwner &&
                context?.promoteMember !== promoteRole.removeFromGroup ? (
                t("Add")
              ) : (
                t("Remove")
              )
            ) : (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{
                      fontSize: "35px",
                      color: "#FFFFFF",
                    }}
                  />
                }
              />
            )}
          </CenterButton>
        )}
      </div>
    </Modal>
  );
};

const FriendForSelect = (props: any) => {
  const { name, profileImage, selected, onSelect } = props;
  return (
    <div className={styles.friendForSelect} onClick={onSelect}>
      <div
        className={styles.profileImage}
        style={{ backgroundImage: `url(${profileImage})` }}
      >
        {selected && (
          <div
            className={styles.selected}
            style={{ backgroundImage: `url(${selectedItemShare})` }}
          />
        )}
      </div>
      <Tooltip placement="top" title={name} color="#0f4c82">
        <div className={styles.friendName}>{name}</div>
      </Tooltip>
    </div>
  );
};

export default ModalRoleAssign;
